import { FetchStatus } from '@as-react/common-types';
import { all, call, getContext, put, select, takeLatest } from 'redux-saga/effects';
import OrdersAPI from '../../../api/OrdersApi';
import { OrdersActionsTypes } from '../../../enums/ActionEnums';
import { analyticsActions } from '../../../redux/analytics/actions/AnalyticsActions.creators';
import { isLoggedInGuestWebReturns } from '../../../util/SessionUtil';
import customerActions from '../../customer/actions/CustomerActions.creators';
import { ordersActions } from '../actions/OrdersActions.creators';
const getIsLoggedInGuestReturns = (state) => isLoggedInGuestWebReturns(state.session);
export function* getOrderedItemsForAuthenticatedUser() {
    try {
        yield put(ordersActions.setOrderedItemsState(FetchStatus.PENDING));
        const { defaultRequestParams, servicesEndpoint } = yield getContext('aemConfiguration');
        const items = yield call(OrdersAPI.getSales, servicesEndpoint, defaultRequestParams);
        yield put(ordersActions.setOrderedItems(items));
        yield put(ordersActions.setOrderedItemsState(FetchStatus.RESOLVED));
    }
    catch (_a) {
        yield put(ordersActions.setOrderedItemsState(FetchStatus.REJECTED));
    }
}
function* getOrderedItemsForGuestUser() {
    try {
        yield put(ordersActions.setOrderedItemsState(FetchStatus.PENDING));
        const { defaultRequestParams, servicesEndpoint } = yield getContext('aemConfiguration');
        const items = yield call(OrdersAPI.getSale, servicesEndpoint, defaultRequestParams);
        yield put(ordersActions.setOrderedItems(items));
        yield put(ordersActions.setOrderedItemsState(FetchStatus.RESOLVED));
    }
    catch (_a) {
        yield put(ordersActions.setOrderedItemsState(FetchStatus.REJECTED));
    }
}
function* getReturnItems() {
    try {
        const isLoggedInGuestReturns = yield select(getIsLoggedInGuestReturns);
        const { defaultRequestParams, servicesEndpoint } = yield getContext('aemConfiguration');
        const items = yield call(isLoggedInGuestReturns ? OrdersAPI.getSale : OrdersAPI.getReturnables, servicesEndpoint, defaultRequestParams);
        yield put(ordersActions.setReturnItems(items));
        if (!isLoggedInGuestReturns) {
            yield put(customerActions.getProfile());
        }
    }
    catch (_a) { }
}
function* getReturnReasons() {
    const { defaultRequestParams, servicesEndpoint } = yield getContext('aemConfiguration');
    const items = yield call(OrdersAPI.getReturnReasons, servicesEndpoint, defaultRequestParams.market, defaultRequestParams.language);
    yield put(ordersActions.setReturnReasons(items));
}
function* submitReturnItems({ payload }) {
    const { defaultRequestParams, servicesEndpoint } = yield getContext('aemConfiguration');
    const isLoggedInGuestReturns = yield select(getIsLoggedInGuestReturns);
    try {
        yield put(ordersActions.setSubmitReturnItemsState(FetchStatus.PENDING));
        const announcedReturn = yield call(isLoggedInGuestReturns ? OrdersAPI.registerReturnAnnounceGuest : OrdersAPI.registerReturnAnnounce, servicesEndpoint, defaultRequestParams, payload);
        yield put(ordersActions.setAnnouncedReturn(announcedReturn));
        yield put(ordersActions.setSubmitReturnItemsState(FetchStatus.RESOLVED));
        yield put(analyticsActions.returnAnnounced(String(payload.returnOptionId)));
    }
    catch (_a) {
        yield put(ordersActions.setSubmitReturnItemsState(FetchStatus.REJECTED));
    }
}
function* updateAnnouncedReturn({ payload }) {
    const { defaultRequestParams, servicesEndpoint } = yield getContext('aemConfiguration');
    try {
        yield put(ordersActions.setUpdateAnnouncedReturnState(FetchStatus.PENDING));
        yield call(OrdersAPI.updateReturnMethod, servicesEndpoint, defaultRequestParams, payload.returnAnnounceId, payload.returnOptionId, payload.returnCountryId);
        yield put(ordersActions.getReturnedSales());
        yield put(ordersActions.setUpdateAnnouncedReturnState(FetchStatus.RESOLVED));
    }
    catch (_a) {
        yield put(ordersActions.setUpdateAnnouncedReturnState(FetchStatus.REJECTED));
    }
}
function* getReturnedSales() {
    try {
        const isLoggedInGuestReturns = yield select(getIsLoggedInGuestReturns);
        const { defaultRequestParams, servicesEndpoint } = yield getContext('aemConfiguration');
        const items = yield call(isLoggedInGuestReturns ? OrdersAPI.getReturnedSalesGuest : OrdersAPI.getReturnedSales, servicesEndpoint, defaultRequestParams);
        yield put(ordersActions.setReturnedSales(items));
    }
    catch (_a) { }
}
export function* getOrderedItemsForAuthenticatedUserSaga() {
    yield takeLatest(OrdersActionsTypes.GET_ORDERED_ITEMS_FOR_AUTHENTICATED_USER, getOrderedItemsForAuthenticatedUser);
}
function* getOrderedItemsForGuestUserSaga() {
    yield takeLatest(OrdersActionsTypes.GET_ORDERED_ITEMS_FOR_GUEST_USER, getOrderedItemsForGuestUser);
}
function* getReturnItemsSaga() {
    yield takeLatest(OrdersActionsTypes.GET_RETURN_ITEMS, getReturnItems);
}
function* getReturnReasonsSaga() {
    yield takeLatest(OrdersActionsTypes.GET_RETURN_REASONS, getReturnReasons);
}
function* submitReturnItemsSaga() {
    yield takeLatest(OrdersActionsTypes.SUBMIT_RETURN_ITEMS, submitReturnItems);
}
function* updateAnnouncedReturnSaga() {
    yield takeLatest(OrdersActionsTypes.UPDATE_RETURN_REASON, updateAnnouncedReturn);
}
function* getAnnouncedReturnsSaga() {
    yield takeLatest(OrdersActionsTypes.GET_RETURNED_SALES, getReturnedSales);
}
export default function* ordersSaga() {
    yield all([
        getOrderedItemsForAuthenticatedUserSaga(),
        getOrderedItemsForGuestUserSaga(),
        getReturnItemsSaga(),
        getReturnReasonsSaga(),
        submitReturnItemsSaga(),
        updateAnnouncedReturnSaga(),
        getAnnouncedReturnsSaga(),
    ]);
}
